import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreateOrganizationV1OrganizationsPostData,
  type CreateOrganizationV1OrganizationsPostError,
  type CreateOrganizationV1OrganizationsPostResponse,
  createOrganizationV1OrganizationsPost,
} from '../../generated';

export type CreateOrganizationMutationVariables = CreateOrganizationV1OrganizationsPostData['body'] &
  NonNullable<CreateOrganizationV1OrganizationsPostData['query']>;

export type CreateOrganizationMutation = CreateOrganizationV1OrganizationsPostResponse;

export const useCreateOrganizationMutation = <TError = CreateOrganizationV1OrganizationsPostError, TContext = unknown>(
  options?: Omit<
    UseMutationOptions<CreateOrganizationMutation, TError, CreateOrganizationMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreateOrganizationMutation, TError, CreateOrganizationMutationVariables, TContext>({
    mutationKey: ['CreateOrganization'],
    mutationFn: async ({ org_id, ...body }: CreateOrganizationMutationVariables) => {
      const { data } = await createOrganizationV1OrganizationsPost({
        query: { org_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreateOrganizationMutation.fetcher = (
  { org_id, ...body }: CreateOrganizationMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createOrganizationV1OrganizationsPost({
      query: { org_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
